// // // ============================================================
// // // src/utils/api.js — API helper with JWT support
// // // ============================================================

// // const BASE_URL = process.env.REACT_APP_API_URL || "https://pearlsmile-backend.onrender.com/api";

// // const getToken = () => localStorage.getItem("pearlsmile_token");

// // const headers = (extra = {}) => ({
// //   "Content-Type": "application/json",
// //   ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
// //   ...extra,
// // });

// // const api = {
// //   get: async (path) => {
// //     const res = await fetch(`${BASE_URL}${path}`, { headers: headers() });
// //     if (!res.ok) {
// //       const err = await res.json().catch(() => ({ message: "Request failed" }));
// //       throw new Error(err.message || "Request failed");
// //     }
// //     return res.json();
// //   },

// //   post: async (path, body) => {
// //     const res = await fetch(`${BASE_URL}${path}`, {
// //       method: "POST",
// //       headers: headers(),
// //       body: JSON.stringify(body),
// //     });
// //     if (!res.ok) {
// //       const err = await res.json().catch(() => ({ message: "Request failed" }));
// //       throw new Error(err.message || "Request failed");
// //     }
// //     return res.json();
// //   },

// //   put: async (path, body) => {
// //     const res = await fetch(`${BASE_URL}${path}`, {
// //       method: "PUT",
// //       headers: headers(),
// //       body: JSON.stringify(body),
// //     });
// //     if (!res.ok) {
// //       const err = await res.json().catch(() => ({ message: "Request failed" }));
// //       throw new Error(err.message || "Request failed");
// //     }
// //     return res.json();
// //   },

// //   delete: async (path) => {
// //     const res = await fetch(`${BASE_URL}${path}`, {
// //       method: "DELETE",
// //       headers: headers(),
// //     });
// //     if (!res.ok) {
// //       const err = await res.json().catch(() => ({ message: "Request failed" }));
// //       throw new Error(err.message || "Request failed");
// //     }
// //     return res.json();
// //   },
// // };

// // export default api;

//////////////////////////////////////this  second code is correct code  Start////////////////

// ============================================================
// src/utils/api.js — API helper with JWT support
// ============================================================

const BASE_URL =
  process.env.REACT_APP_API_URL || "https://pearlsmial.pearlsmilefresh.com/api";

// const BASE_URL =
//   process.env.REACT_APP_API_URL ||
//   "https://pearlsmile-backend.onrender.com/api";

// const BASE_URL =
//   process.env.REACT_APP_API_URL || "https://pearlsmilefresh.com/api";

const getToken = () => localStorage.getItem("pearlsmile_token");

const headers = (extra = {}) => ({
  "Content-Type": "application/json",
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
  ...extra,
});

const api = {
  get: async (path) => {
    const res = await fetch(`${BASE_URL}${path}`, { headers: headers() });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },

  post: async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "POST",
      headers: headers(),
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },

  put: async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "PUT",
      headers: headers(),
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },

  patch: async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "PATCH",
      headers: headers(),
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },

  delete: async (path) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "DELETE",
      headers: headers(),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },
};

export default api;

////////////////////////// newly added code is below above code is correct 1:17
